import React from 'react'
import { Dialog, Button } from 'components/ui'
import PropTypes from 'prop-types'
import { HiOutlineExclamationCircle } from 'react-icons/hi'

const ResendInviteDialog = ({
    isOpen,
    onClose,
    onConfirm,
    loading,
    entityType = 'profile',
}) => {
    const handleConfirm = () => {
        onConfirm()
    }

    return (
        <Dialog
            isOpen={isOpen}
            onClose={onClose}
            width={600}
            style={{ marginTop: 150 }}
        >
            <div className="px-6 py-4">
                <div className="flex items-center gap-3 mb-4">
                    <div className="text-amber-500 text-3xl">
                        <HiOutlineExclamationCircle />
                    </div>
                    <h5>Re-send Invite?</h5>
                </div>

                <div className="mb-6">
                    <p className="mb-3">
                        Are you sure you want to re-send the invitation email to
                        this {entityType}?
                    </p>
                    <div className="flex items-start gap-2 p-3 bg-amber-100 text-amber-700 dark:bg-amber-500/20 dark:text-amber-100 rounded">
                        <HiOutlineExclamationCircle className="text-xl flex-shrink-0 mt-0.5" />
                        <div className="text-sm">
                            <strong>Important:</strong> Re-sending the invite
                            will invalidate all previously sent or generated
                            invite links. Only the new invite link will be valid
                            for registration.
                        </div>
                    </div>
                </div>

                <div className="flex justify-end gap-2">
                    <Button size="sm" onClick={onClose} disabled={loading}>
                        Cancel
                    </Button>
                    <Button
                        size="sm"
                        variant="solid"
                        color="amber-600"
                        onClick={handleConfirm}
                        loading={loading}
                    >
                        Re-send Invite
                    </Button>
                </div>
            </div>
        </Dialog>
    )
}

ResendInviteDialog.propTypes = {
    isOpen: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired,
    onConfirm: PropTypes.func.isRequired,
    loading: PropTypes.bool,
    entityType: PropTypes.string,
}

export default ResendInviteDialog
